<ng-container *ngIf="config">
	<div class="msj_validacion val_error" [ngClass]="config.style">
		<i [class]="config.ficon"></i>
		<p *ngIf="message" [innerHtml]="message"></p>
	</div>
</ng-container>
